/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const tooltipTokens = {
  ContainerBackgroundColorBaseDefault: '#1c2222',
  ContainerBackgroundColorNegativeDefault: '#f8d2d8',
  ContainerBorderColorBaseDefault: '#1c2222',
  ContainerBorderColorNegativeDefault: '#f0a4b1',
  ContainerBorderRadiusBaseDefault: '0px',
  ContainerBorderWidthBaseDefault: '1px',
  ContainerElevationBaseDefault: '1100',
  ContainerFontColorBaseDefault: '#ffffff',
  ContainerFontColorNegativeDefault: '#c41936',
  ContainerFontSizeBaseDefault: '14px',
  ContainerFontWeightBaseDefault: '400',
  ContainerFontLeadingBaseDefault: '24px',
  ContainerSpacingOuterBaseDefault: '10px',
} as const;
